<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="flex-col">
    <div class="mb-4">
      <h3 class="pb-2" color="primary">Upload Link</h3>
      <div class="pb-2 flex-row">Any person with the link below will be able to upload files to execute the selected moov configuration:</div>
      <ul class="ml-4">
        <li><strong>moov:</strong>&nbsp;{{moovConfiguration.moovDefinition.name}}</li>
        <li><strong>Client Name</strong>:&nbsp;{{client.name}}</li>
        <li><strong>File Name Starts With:</strong>&nbsp;{{moovConfiguration.filenameStartsWith}}</li>
        <li><strong>File Name Contains:&nbsp;</strong>{{moovConfiguration.filenameContains}}</li>
      </ul>
    </div>
    @if (url) {
      <div class="w-100 flex-row">
        <div class="w-10 link-icon">
          <mat-icon>link</mat-icon>
        </div>
        <input [value]="url" class="pl-3 url-field w-70" type="text" readonly matInput appearance="outline" disabled>
        <button class="w-20" (click)="onCopyClick(url)" color="primary" mat-raised-button>Copy</button>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button class="dialog-btn " color="primary" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
  </div>
</mat-dialog-actions>